export default __webpack_public_path__ + "static/media/23-annual-football-tournament.cd727cf9.jpeg";